import actions from './actions';
import mutations from './mutations';
import stateFactory from './state';
import VueTableModule from "~/components/vuetable/store";

const state = stateFactory.getDefaultState();
const mfaResetTableState = stateFactory.getDefaultMfaResetTableState();

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        mfaResetVuetable: {
            namespaced: true,
            actions: VueTableModule.actions,
            mutations: VueTableModule.mutations,
            state: VueTableModule.state(mfaResetTableState)
        }
    },
};
